export default {
  instagram: 'https://www.instagram.com/becomefound',
  tiktok: 'https://www.tiktok.com/@becomefound',
  facebook: 'https://www.facebook.com/people/Found/100083839633408'
};
